import { render, staticRenderFns } from "./appMg.vue?vue&type=template&id=0b2a72da&scoped=true&"
import script from "./appMg.vue?vue&type=script&lang=js&"
export * from "./appMg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2a72da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b2a72da')) {
      api.createRecord('0b2a72da', component.options)
    } else {
      api.reload('0b2a72da', component.options)
    }
    module.hot.accept("./appMg.vue?vue&type=template&id=0b2a72da&scoped=true&", function () {
      api.rerender('0b2a72da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/financial/googleAds/appMg.vue"
export default component.exports